export default "__VITE_ASSET__CjrFyVVS__"